import { useCheckoutDraft } from '@/entities/order'
import { getTraceId } from '@/shared/api'
import { ENV } from '@/shared/config'
import { useTranslation } from '@/shared/i18n'
import { closeMiniApp, openUrl } from '@/shared/telegram'
import { StateView } from '@/widgets/state-view'

type ReopenAppPageProps = {
  /** Отказ `TG-004` — его trace-id идёт в код на экране. */
  error: unknown
}

/**
 * «Откройте приложение заново» — подпись Telegram старше суток (`TG-004`).
 *
 * Не ошибка: Mini App просто долго был открыт. Повтор запроса не поможет —
 * та же `initData` даст тот же отказ, свежую выдаёт только перезапуск. Поэтому
 * главное действие — закрыть приложение, а не «Обновить». Haptic нет: экрана
 * нет в карте откликов, и это не сбой.
 *
 * Про черновик — только если он есть, и ровно то, что с ним будет: после
 * перезапуска Mini App откроется на витрине (или на подарке из чата), а имя
 * получателя и поздравление подставятся в чекаут любого номинала — черновик
 * один на все и живёт неделю (`entities/order/model/checkout-draft.ts`).
 *
 * В макете экрана нет — собран на общем шаблоне отказов (CLAUDE.md,
 * «Авторизация»); тексты ждут ревью.
 */
export const ReopenAppPage = ({ error }: ReopenAppPageProps) => {
  const { t } = useTranslation()
  const draft = useCheckoutDraft()
  const traceId = getTraceId(error)
  const hasDraft = draft.recipientName.trim() !== '' || draft.message.trim() !== ''

  return (
    <StateView
      icon="history"
      title={t('reopenApp.title')}
      text={hasDraft ? `${t('reopenApp.text')} ${t('reopenApp.draftKept')}` : t('reopenApp.text')}
      code={traceId ? `TG-004 · trace-id · ${traceId}` : 'TG-004'}
      mainButton={{ text: t('reopenApp.close'), onClick: closeMiniApp }}
      secondary={ENV.SUPPORT_URL ? { label: t('common.support'), onClick: () => openUrl(ENV.SUPPORT_URL) } : null}
    />
  )
}
